import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table17 = ({ pasokhgooyiScore, setPasokhgooyiScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)

  const [data, setData] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.pasokhgooyi;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setPasokhgooyiScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "pasokhgooyi": selectedItem }))
    }
  }, [reload])
  return (
    <div>
      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          اندازه تاثیرات خیلی کم،
          نقش شغل در پیامدها و
          نتایج دور و غیرمستقیم
        </Column>
        <Column paddingY={30}>
          اندازه تاثیرات کم، نقش
          شاغل در پیامدها و نتایج
          نسبتاً دور و مشارکتی
        </Column>
        <Column paddingY={30}>
          اندازه تاثیرات
          متوسط، نقش شغل
          در پیامدها و نتایج
          نسبتاً مستقیم
        </Column>
        <Column paddingY={30}>
          اندازه تاثیرات زیاد،
          نقش شغل در پیامدها
          و نتایج مستقیم و
          مرتبط
        </Column>
        <Column paddingY={30}>
          اندازه تاثیرات خیلی زیاد،
          نقش شغل در پیامدها و
          نتایج کاملا مستقیم،
          کاملا مرتبط و مبنایی
        </Column>
      </Row>
      <Row>
        <Column isActive={pasokhgooyiScore == 8}> 8</Column>
        <Column isActive={pasokhgooyiScore == 16}>16 </Column>
        <Column isActive={pasokhgooyiScore == 24}>24 </Column>
        <Column isActive={pasokhgooyiScore == 32}> 32</Column>
        <Column isActive={pasokhgooyiScore == 40}> 40</Column>
      </Row>
    </div>
  );
};

export default Table17;
